import { dataLayer } from "@repo/analytics/data-layer-utils";
import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";

/**
 * Logs DL + CleverTap event when a FAQ dropdown is clicked.
 *
 * @param section_title - The main section title where the FAQ is listed
 * @param sub_section - The specific sub-section or question clicked
 */
export const handleFaqDL = (
  loginStatus: string,
  section_title: string,
  sub_section: string,
) => {
  const data = {
    component: componentNameConstants.FAQ,
    cta_text: "arrow",
    element: dlElementConstants.FAQ_DROPDOWN,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.ICON_CLICK,
    section_title,
    sub_section,
  };

  const cleverTapObj = {
    EVENT_NAME: dlElementConstants.FAQ_DROPDOWN,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};
